// /privacy — Privacy Policy (public, no auth). Static page without a data
// layer: the wording lives in the `legal.privacy.*` i18n catalog (draft text;
// the owner approves the final edit via PR review).

import type { ReactElement } from 'react';

import { LegalPageLayout, type LegalSection } from './LegalPageLayout.js';

/** Revision of the current draft; update together with the catalog wording. */
const PRIVACY_REVISION_DATE = new Date(2026, 9, 21);

const SECTIONS: readonly LegalSection[] = [
  {
    titleKey: 'crm.legal.privacy.account_data.title',
    bodyKey: 'crm.legal.privacy.account_data.body',
  },
  {
    titleKey: 'crm.legal.privacy.crm_data.title',
    bodyKey: 'crm.legal.privacy.crm_data.body',
  },
  {
    titleKey: 'crm.legal.privacy.telegram_data.title',
    bodyKey: 'crm.legal.privacy.telegram_data.body',
  },
  {
    titleKey: 'crm.legal.privacy.logs.title',
    bodyKey: 'crm.legal.privacy.logs.body',
  },
  {
    titleKey: 'crm.legal.privacy.retention.title',
    bodyKey: 'crm.legal.privacy.retention.body',
  },
  {
    titleKey: 'crm.legal.privacy.rights.title',
    bodyKey: 'crm.legal.privacy.rights.body',
  },
  {
    titleKey: 'crm.legal.privacy.telegram_privacy.title',
    bodyKey: 'crm.legal.privacy.telegram_privacy.body',
  },
  {
    titleKey: 'crm.legal.privacy.contacts.title',
    bodyKey: 'crm.legal.privacy.contacts.body',
  },
];

export function PrivacyPage(): ReactElement {
  return (
    <LegalPageLayout
      titleKey="crm.legal.privacy.title"
      introKey="crm.legal.privacy.intro"
      updatedKey="crm.legal.updated"
      revisionDate={PRIVACY_REVISION_DATE}
      sections={SECTIONS}
      relatedLinks={[
        { to: '/terms', labelKey: 'crm.legal.link.terms' },
        { to: '/support', labelKey: 'crm.legal.link.support' },
      ]}
    />
  );
}
